// extracted by mini-css-extract-plugin
module.exports = {"root":"StreamTitle__root--3O3F1","bounce":"StreamTitle__bounce--2BiIu"};